import { Heart } from 'lucide-react';
import Link from 'next/link';

export function Copyright() {
  const currentYear = new Date().getFullYear();
  return (
    <div className="flex flex-col items-center gap-2 md:flex-row md:justify-between text-xs text-muted-foreground">
      <p className="flex items-center gap-1">Built with <Heart className="h-3 w-3 fill-primary text-primary" /> for schools by <a href="https://admin-4you.com" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors underline underline-offset-2">Admin4You</a></p>
      <div className="flex items-center gap-3">
        <Link href="/terms" className="hover:text-foreground transition-colors underline underline-offset-2">
          Terms of Use
        </Link>
        <span aria-hidden="true">·</span>
        <Link href="/privacy" className="hover:text-foreground transition-colors underline underline-offset-2">
          Privacy Policy
        </Link>
        <span aria-hidden="true">·</span>
        <p>© {currentYear} Admin4You</p>
      </div>
    </div>
  );
}
